module.exports = __webpack_public_path__ + "media/site_templates/www.hirelocalplumbers.com.au/images/feature_3-d6bec65b6b45fec92a05e49bc4d33803.jpeg";